import { render, staticRenderFns } from "./asesoresb.vue?vue&type=template&id=44860e30"
import script from "./asesoresb.vue?vue&type=script&lang=js"
export * from "./asesoresb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports